import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { SamwebBrick } from '../../samweb-brick.decorator';
import { faBorderAll } from '@fortawesome/pro-duotone-svg-icons';
import { BrickCategory } from '../../../../samwebDescription/samweb/brickCategoryType';
import { BasicBrickComponent } from '../../basic-brick-component';
import { InnerWallBrickSettingsState } from '../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.state';
import { InnerWallBrickSettingsComponent } from './inner-wall-brick-settings/inner-wall-brick-settings.component';
import { gridDefaultValueForInnerWallBrick } from '../../../dashboard/brick-wall/data/grid-default-values';
import { GridsterConfig } from 'angular-gridster2';
import { merge, Observable, Subject } from 'rxjs';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { BrickWallState } from '../../../../store/dashboard/brick-wall/brick-wall.state';
import _ from 'lodash';
import { auditTime, delay, filter, map, takeUntil, tap } from 'rxjs/operators';
import { InnerBrickWallSelectedInTabBrick } from '../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/inner-wall-brick-settings/inner-wall-brick-settings.actions';
import { PilotPanelState } from 'src/app/store/dashboard/pilot-panel/pilot-panel.state';

@Component({
   selector: 'samweb-inner-wall-brick',
   templateUrl: './inner-wall-brick.component.html',
   styleUrls: ['./inner-wall-brick.component.scss'],
})
@SamwebBrick({
   brickDefinitionId: 'innerWall',
   brickTitleTranslationKey: 'brick.brick_definitions.inner_wall_brick.title',
   brickDescriptionTranslationKey: 'brick.brick_definitions.inner_wall_brick.description',
   brickIcon: faBorderAll,
   minColWidth: 10,
   minRowHeight: 10,
   brickCategory: BrickCategory.LAYOUT,
   settingsComponent: InnerWallBrickSettingsComponent,
   settingStateHandler: InnerWallBrickSettingsState,
   isLayoutBrick: true,
   allowBrickOverflow: true,
})
export class InnerWallBrickComponent extends BasicBrickComponent implements AfterViewInit, OnDestroy, OnInit {
   public brickInstanceId: Readonly<string>;

   public options: GridsterConfig;

   public brickInstanceIds$: Observable<string[]>;

   private destroy$ = new Subject();

   constructor(private store: Store, private actions$: Actions) {
      super();
      this.options = gridDefaultValueForInnerWallBrick();
   }

   ngOnInit(): void {
      this.brickInstanceIds$ = this.store.select(InnerWallBrickSettingsState.brickInstanceIdsForInnerWallBrickFn).pipe(map((fn) => fn(this.brickInstanceId)));

      this.actions$
         .pipe(
            ofActionDispatched(InnerBrickWallSelectedInTabBrick),
            filter((action: InnerBrickWallSelectedInTabBrick) => action.innerBrickWallBrickInstanceId === this.brickInstanceId),
            takeUntil(this.destroy$)
         )
         .subscribe(() => {
            if (_.isNil(this.options.api)) {
               return;
            }
            this.options.api.optionsChanged();
         });

      merge(this.store.select(BrickWallState), this.brickInstanceIds$)
         .pipe(delay(10), takeUntil(this.destroy$))
         .subscribe(() => {
            if (_.isNil(this.options.api)) {
               return;
            }
            this.options.api.optionsChanged();
         });
   }

   ngAfterViewInit(): void {
      merge(this.store.select(PilotPanelState.isPilotPanelExtended))
         .pipe(
            auditTime(150),
            tap(() => {
               if (_.isNil(this.options.api)) {
                  return;
               }
               setTimeout(() => {
                  this.options.api.resize();
               }, 0);
            }),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   onResize(event) {
      setTimeout(() => {
         if (_.isNil(this.options.api)) {
            return;
         }
         this.options.api.resize();
      }, 150);
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
